import CryptoJS from 'crypto-js'
import vue from '@/page/cw/main'
import moment from 'moment'

// 版本对应数字
export const versionVal = {
    // 基础版
    base: '2',
    base_new: '17', // 新增新版本 跟 基础班类似
    // 标准版
    normal: '3',
    // 旗舰版
    ultimate: '4',
    // 站长基础版
    webMaster: '11',
    // 站长旗舰版
    webMasterSenior: '12',
    //入门版
    entryLevel:'16',
}

// 变密
export function encrypt (param, code, sign) {
    code = CryptoJS.enc.Utf8.parse(CryptoJS.MD5(code).toString())
    sign = CryptoJS.enc.Utf8.parse(sign)
    let encrypted = CryptoJS.AES.encrypt(param, code, {
        iv: sign,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
}

// 部分表单验证 （不包含确认密码等复杂验证）
export const verify = (param) => {
    return {
        // 用户名
        username: [
            { required: true, message: '请输入帐号', trigger: 'blur' },
        ],
        password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        phone: [
            {
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback(new Error('请输入用户预留手机号'))
                    }
                    if (!(/^1[34578]\d{9}$/.test(value))) {
                        callback(new Error('请输入正确的11位手机号码'))
                    }
                    // 一定要加上这个回调，虽然我也不知道这个回调从哪来的
                    callback()
                },
                trigger: 'blur'
            }
        ],
        code: [
            // { required: true, message: '请输入短信验证码', trigger: 'blur' }
            {
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback(new Error('请输入短信验证码'))
                    }
                    if (!(/^\d{6}$/.test(value))) {
                        callback(new Error('请输入正确的6位纯数字验证码'))
                    }
                    callback()
                },
                trigger: 'blur'
            }
        ]
    }
}


// ufile第三方文件上传相关工具
// 存储空间名称。既可以在这里配置，也可以在SDK中全局配置。
// 例如 var bucketName = "example-name";
var bucketName = "";
// 存储空间域名URL地址。既可以在这里配置，也可以在SDK中全局配置。
// 例如 var bucketUrl = "https://example-name.cn-bj.ufileos.com/";
var bucketUrl = "";
// 计算token的地址。既可以在这里配置，也可以在SDK中全局配置。
// 例如 var tokenUrl = "token_server.php";
var tokenUrl = "";
var ImgType = true;
//判断图片类型
function ImagesType(file) {
    var nameArr = file.name.split('.')
    var nameType = nameArr[nameArr.length-1]
    if(nameType !='jpg' && nameType!='jpeg' && nameType!='png' && nameType!='JPG' && nameType!='JPEG' && nameType!='PNG') {
        ImgType = false
        vue.$message.error('请上传正确格式的图片');
    } else {
        ImgType = true
    }
}


//通过js的内置对象JSON来进行数组对象的深拷贝
export function deepClone(obj) {
  var _obj = JSON.stringify(obj),
    objClone = JSON.parse(_obj);
  return objClone;
}

// 后台返回的时间是‘2021-06-24T16:59:54.253299+08:00’这个格式的处理方法
export function formatDate(date, isUTC = true, format = 'YYYY-mm-dd HH:MM:SS'){
  date = new Date(date);
    const dataItem = {
      'Y+': date.getFullYear().toString(),
      'm+': (date.getMonth() + 1).toString(),
      'd+': date.getDate().toString(),
      'H+': date.getHours().toString(),
      'M+': date.getMinutes().toString(),
      'S+': date.getSeconds().toString(),
    };
    Object.keys(dataItem).forEach((item) => {
      const ret = new RegExp(`(${item})`).exec(format);
      if (ret) {
        format = format.replace(ret[1], ret[1].length === 1 ? dataItem[item] : dataItem[item].padStart(ret[1].length, '0'));
      }
    });
    return format;
}



// WEBPACK FOOTER //
// ./src/page/cw/tools.js